import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.authService.recuperarToken();
    const isNgrok = request.url.includes('ngrok');
    const extraHeaders: Record<string, string> = isNgrok
      ? { 'ngrok-skip-browser-warning': '1' }
      : {};

    if (token) {
      request = request.clone({
        setHeaders: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          ...extraHeaders,
        },
      });
    } else if (isNgrok) {
      request = request.clone({ setHeaders: extraHeaders });
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401 || err.status === 403) {
          this.authService.limparAutorizacao();
          this.router.navigate(['/auth/login']).then(() => {
            window.location.reload();
          });
        }
        return throwError(err);
      })
    );
  }
}
